import { rServices } from '@/plugins/api';
import { REPORT_TYPES } from '@/constants/reports';
import { LEVEL_TYPES } from '@/constants/level';

export const buildReportPayload = ({ type, event, rootEventId, level = 0, nominationId, pollId }) => {
  if (!event) return {};

  const payload = {
    root_event_id: rootEventId ? Number(rootEventId) : undefined,
    level,
  };
  const isLevelMenu = ![
    REPORT_TYPES.events_statistics,
    REPORT_TYPES.operator_summary_events_table,
    REPORT_TYPES.operator_summary_members_table,
    REPORT_TYPES.department_summary_events_table,
    REPORT_TYPES.department_summary_members_table,
    REPORT_TYPES.multilevel_event_members_information,
    REPORT_TYPES.examination_report,
  ].includes(type);
  const needEventId = [
    REPORT_TYPES.export_members_by_nominations,
    REPORT_TYPES.local_level_members,
    REPORT_TYPES.subordinated_members_count,
    REPORT_TYPES.tournament_event_stage_users_list,
  ];

  if (isLevelMenu) {
    if ([LEVEL_TYPES.REGIONAL, LEVEL_TYPES.MUNICIPAL].includes(event.level.id)) {
      payload.main_event_id = Number(rootEventId);
    }
  } else {
    delete payload.level;
  }
  if (nominationId) payload.nomination_id = nominationId;
  if (pollId) payload.poll_id = pollId;
  if (needEventId.includes(type)) payload.event_id = event.id;

  const needOnlyEventId = [
    REPORT_TYPES.subordinated_members_count,
    REPORT_TYPES.export_members_by_nominations,
    REPORT_TYPES.local_level_members,
  ];
  if (needOnlyEventId.includes(type)) {
    Object.keys(payload).forEach((key) => {
      if (key !== 'event_id') delete payload[key];
    });
  }
  return payload;
};

export const ReportsManager = {
  list({ type, event, params = {} }) {
    const noNeedEventId = [
      REPORT_TYPES.export_members_by_nominations,
      REPORT_TYPES.local_level_members,
    ];
    return rServices.events.getReports({
      params: {
        ...params,
        sort: '-id',
        'search[type]': type,
        ...event && !noNeedEventId.includes(type) ? { 'search[event_id]': event.id } : {},
        expand: 'params,exportable_type',
      },
    });
  },
  create(options) {
    const { type } = options;
    const request = { args: [type], data: buildReportPayload(options) };
    return type === REPORT_TYPES.events_statistics
      ? rServices.events.createReportAnalytic(request)
      : rServices.events.createReport(request);
  },
  remove({ args }) {
    return rServices.events.removeReports({ args });
  },
};
